export type SetType = 'set' | 'promo' | 'deck' | 'collection' | 'energy' | 'vending' | 'other'

export const SET_TYPE_OPTIONS: Array<{ value: SetType; label: string }> = [
  { value: 'set', label: 'Sets' },
  { value: 'promo', label: 'Promos' },
  { value: 'deck', label: 'Decks' },
  { value: 'collection', label: 'Collections' },
  { value: 'energy', label: 'Energies' },
  { value: 'vending', label: 'Vending' },
  { value: 'other', label: 'Other' },
]

export interface SearchGame {
  id: string
  name: string
  slug: string
  sets?: Array<{ id: string; hasCached?: boolean | null; lastSyncedAt?: string | null }>
}

export interface SearchSet {
  id: string
  name: string
  code: string
  setType?: SetType
  releaseDate?: string
  language?: string
}
